<script>
    export let width = undefined;
    export let height = undefined;
</script>

<div style="width:{width}px; height:{height}px; ">
    <slot/>
</div>
